export const validateNumber = num => {
  const regex = /^(\d{0,2}(\.\d{1,2})?|100(\.00?)?)$/
  return regex.test(num)
}

export const isValidPercentage = value => {
  return /^((100(\.0{0,2})?)|([1-9]?\d(\.\d{1,2})?))$/.test(value)
}
